import Vue from 'vue'

// 引入时间格式插件
import moment from  './moment'

// 引入dsBridge
import jsBridge from './jsBridge'

// 引入公共方法
import common from './common'

// 注册方法
Vue.use(moment);
Vue.use(common);

// dsBridge添加到实例
Vue.prototype.$jsBridge = jsBridge
